import styled from "styled-components";
import {Table} from "antd";


const columnsVisitsTable = [
    {
        title: "Тип карты",
        dataIndex: "template",
        width: 120,
    },
    {
        title: "Визитов",
        dataIndex: "unique",
        width: 80,
        render: (value) => (
            <StyledSum>
                {value
                    ? new Intl.NumberFormat("ru-RU").format(Number(value))
                    : 0}
            </StyledSum>
        ),
    },
    {
        title: "Потрачено бонусов",
        dataIndex: "bonus",
        width: 80,
        render: (value) => (
            <StyledSum>
                {value
                    ? new Intl.NumberFormat("ru-RU").format(Number(value))
                    : 0}
            </StyledSum>
        ),
    },
    {
        title: "Потрачено депозитов",
        dataIndex: "balance",
        width: 80,
        render: (value) => (
            <StyledSum>
                {value
                    ? new Intl.NumberFormat("ru-RU").format(Number(value))
                    : 0}
            </StyledSum>
        ),
    },
];

export {
    columnsVisitsTable,
};

const AcceptedLabel = styled.div`
    /* Frame 427322058 */

    box-sizing: border-box;

    width: 133px;
    height: 38px;
    /* #8F8F8F 30% */
    border: 1px solid rgba(143, 143, 143, 0.3);
    border-radius: 5px;
    /* Подтвержден */

    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
    /* identical to box height, or 200% */
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    /* Текст/#333333 текст|кнопки */
    color: #333333;

    & span {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        /* identical to box height, or 200% */
        color: #dd1a6a;
    }
`;

const StyledSum = styled.div`
    text-align: right;
    padding-right: 20%;
`;

const Sspan = styled.span`
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 28px;
    /* identical to box height, or 200% */
    text-align: right;

    /* Текст/#333333 текст|кнопки */
    color: #333333;
`;

const Nspan = styled.span`
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    /* identical to box height, or 200% */
    text-align: right;

    /* Текст/#8F8F8F текст */
    color: #8f8f8f;
`;
